import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "../styles/Signup.css";

const LoginForm = () => {

  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  });

  const handleChange = (e) => {

    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value
    });

  };

  const handleLogin = (e) => {

    e.preventDefault();

    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (
      storedUser &&
      storedUser.email === loginData.email &&
      storedUser.password === loginData.password
    ) {

      toast.success("Login Successful 🚀");

      setTimeout(() => {
        navigate("/dashboard");
      }, 1500);

    } else {
      toast.error("Invalid Credentials");
    }

  };

  return (

    <div className="signup-container">

      <Toaster position="top-center"/>

      <form className="signup-form" onSubmit={handleLogin}>

        <h2>Login</h2>

        <input
          type="email"
          name="email"
          placeholder="Enter Email"
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Enter Password"
          onChange={handleChange}
          required
        />

        <button type="submit">Login</button>

        <p className="login-link">
          Don't have an account?
          <span onClick={() => navigate("/")}> Signup</span>
        </p>

      </form>

    </div>

  );
};

export default LoginForm;